<template>
    <v-layout wrap>
        <v-flex class="mb-1 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('appointments-list') }}</h1>
                <v-tooltip bottom>
                    <v-btn flat icon slot="activator">
                        <v-icon>mdi-help-circle</v-icon>
                    </v-btn>
                    <span>{{ $t('help') }}</span>
                </v-tooltip>
                <!--<v-tooltip bottom>
                    <v-btn @click="openReport()" flat icon slot="activator">
                        <v-icon>mdi-file-chart</v-icon>
                    </v-btn>
                    <span>{{ $t('report') }}</span>
                </v-tooltip>-->
            </div>
            <!-- Appointments -->
            <div class="text-xs-right">
                <v-btn :to="{ name: 'add-appointments' }" color="success" v-can:add>
                    <v-icon left>add</v-icon>
                    {{ $t('add-new-appointment') }}
                </v-btn>
                <v-menu bottom left min-width="100" origin="center center" transition="scale-transition" v-if="selected.length">
                    <v-btn flat icon slot="activator">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                        <v-list-tile @click="deleteAppointments" v-can:delete>
                            <v-list-tile-title>Delete</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="postAppointments" v-can:post>
                            <v-list-tile-title>Post</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="unpostAppointments" v-can:unpost>
                            <v-list-tile-title>Unpost</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </v-flex>
        <!-- Search box -->
        <v-flex xs12>
            <v-card class="pa-2 pt-3 mb-3">
                <v-form @submit.prevent="getAppointments">
                    <v-layout wrap>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-text-field :label="$t('search')"
                                          append-icon="mdi-magnify"
                                          hide-details
                                          single-line
                                          v-model="filter.keyword"></v-text-field>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-menu :close-on-content-click="false"
                                    :nudge-right="40"
                                    full-width
                                    lazy
                                    min-width="290px"
                                    offset-y
                                    ref="menu"
                                    transition="scale-transition"
                                    v-model="fromDateMenu">
                                <v-text-field :data-vv-as="$t('from-date')"
                                              :label="$t('from-date')"
                                              clearable
                                              name="fromDate"
                                              prepend-icon="event"
                                              readonly
                                              slot="activator"
                                              v-model="filter.fromDate"></v-text-field>
                                <v-date-picker :max="filter.toDate ? filter.toDate : ''"
                                               @change="fromDateMenu = false"
                                               min="1900-01-01"
                                               ref="picker"
                                               v-model="filter.fromDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-menu :close-on-content-click="false"
                                    :nudge-right="40"
                                    full-width
                                    lazy
                                    min-width="290px"
                                    offset-y
                                    ref="menu"
                                    transition="scale-transition"
                                    v-model="toDateMenu">
                                <v-text-field :data-vv-as="$t('to-date')"
                                              :label="$t('to-date')"
                                              clearable
                                              name="toDate"
                                              prepend-icon="event"
                                              readonly
                                              slot="activator"
                                              v-model="filter.toDate"></v-text-field>
                                <v-date-picker :min="filter.fromDate ? filter.fromDate : '1900-01-01'"
                                               @change="toDateMenu = false"
                                               ref="picker"
                                               v-model="filter.toDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('governorate')"
                                            :error-messages="errors.collect('governoratecity')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="governoratesList"
                                            :label="$t('governorate')"
                                            clearable
                                            item-value="code"
                                            name="governoratecity"
                                            v-model="filter.governorate"></v-autocomplete>
                        </v-flex>

                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('disability-type')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="disabilityNaturesList"
                                            :label="$t('disability-type')"
                                            clearable
                                            item-value="code"
                                            name="typeOfDisability"
                                            v-model="filter.typeOfDisability"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn color="primary" type="submit">{{ $t('filter') }}</v-btn>
                            <v-btn color="primary" type="reset" @click="resetForm()">{{ $t('reset') }}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card>
        </v-flex>
        <!-- Data Table -->
        <v-flex xs12>
            <v-data-table :rows-per-page-items="[10, 25, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]"
                          :headers="headers"
                          :items="appointments"
                          :loading="isLoading"
                          class="elevation-1"
                          select-all
                          v-model="selected">
                <template slot="items" slot-scope="props">
                    <tr :key="props.index" :class="props.item.isActive ? '' : 'is-posted'">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>

                        <!--<td>{{ props.item.doctorName }}</td>-->
                        <td>{{ props.item.fullname }}</td>
                        <td>{{ props.item.nationalityNO }}</td>
                        <td>{{ props.item.appointmentsDate | date }}</td>
                        <td>{{ props.item.telphone1   }}</td>
                        <td>{{ props.item.telphone2  }}</td>
                        <td>
                            <v-btn icon
                                   v-can:edit
                                   :to="{
                  name: 'edit-appointments',
                  params: { beneficiaryInformationId: props.item.beneficiaryInfoManagementId, id: props.item.id }
                }">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </td>
                        <!--<td>
        <v-icon v-show="props.item.isActive">mdi-account-check mdi-36px</v-icon>
        <v-icon v-show="!props.item.isActive">mdi-check-outline</v-icon>
    </td>-->
                    </tr>
                </template>
            </v-data-table>
            <v-btn color="primary" type="reset" @click="deleteAppointments()">{{ $t('delete') }}</v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';
    import AppointmentsService from '@/services/Disabilities/PersonWithDisabilities/AppointmentsService';
    import LookUpService from '@/services/LookUpService';

    export default {
        name: 'appointments',
        data() {
            return {
                appointments: [],
                governoratesList: [],
                disabilityNaturesList: [],
                selected: [],
                filter: {
                    keyword: '',
                    fromDate: '',
                    toDate: '',
                    governorate: '',
                    typeOfDisability: '',
                },
                fromDateMenu: false,
                toDateMenu: false,
                isLoading: false
            };
        },
        created() {
            this.getAppointments();
            this.getGovernorates();
            this.getDisabilityNatures();
        },
        methods: {
            resetForm() {
                this.filter = {
                    keyword: '',
                    fromDate: '',
                    toDate: '',
                    governorate: '',
                    typeOfDisability: '',
                };
                this.getAppointments();
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
             async getDisabilityNatures() {
                this.disabilityNaturesList = (await LookUpService.getLookup(112)).data;
            },
            async getAppointments() {
                this.appointments = [];
                this.isLoading = true;
                const appointments = (await AppointmentsService.getAppointmentsByCriteria(this.filter)).data;
                this.appointments = appointments;
                this.isLoading = false;
            },
            async deleteAppointments() {
                this.$store.dispatch('confirm');
                ConfirmationEvent.$on('onSuccess', async () => {
                    /* Show loading on delete users */
                    this.$store.dispatch('showLoading');
                    const result = await AppointmentsService.deleteAppointments(this.selectedIds);
                    this.selected = [];
                    this.$store.dispatch('hideLoading');
                    if (result.data.statusCode === 200) {
                        var firstIndexOf = result.data.message.indexOf('(') + 1;
                        var lastIndexOf = result.data.message.indexOf(')');
                        var gropsNames = result.data.message.substring(firstIndexOf, lastIndexOf);
                        var arrayNames = gropsNames.split(',');
                        var displayString = `${this.$t('delete')} ${arrayNames.length} ${this.$t('appointments')}`;
                        arrayNames.forEach((appointment, index) => {
                            displayString += `\n ${index + 1} - ${appointment}`;
                        });
                        this.$store.dispatch('showMessage', {
                            text: displayString,
                            multiLine: true
                        });
                    } else {
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            color: 'error'
                        });
                    }
                    this.getAppointments();
                });
            },
            async postAppointments() {
                let postAppointments = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postAppointments.push({ id: this.selectedIds[i].id, isActive: true });
                }
                const result = await AppointmentsService.postAppointments(postAppointments);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getAppointments();
            },
            async unpostAppointments() {
                let postAppointments = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postAppointments.push({ id: this.selectedIds[i].id, isActive: false });
                }
                const result = await AppointmentsService.postAppointments(postAppointments);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getAppointments();
            }
        },
        computed: {
            selectedIds() {
                return this.selected.map(appointment => ({ id: appointment.id }));
            },

            headers() {
                return [
                    //{ text: this.$t('doctor-name'), value: 'doctorName', sortable: false },
                    { text: this.$t('full-name'), value: 'fullname', sortable: false },
                    { text: this.$t('national-number'), value: 'nationalityNO', sortable: false },
                    { text: this.$t('appointment-date'), value: 'appointmentsDate', sortable: false },
                    { text: this.$t('mobile-number'), value: 'telphone1', sortable: false },
                    { text: this.$t('another-mobile-number'), value: 'telphone2', sortable: false },
                    { text: this.$t('edit'), value: '', sortable: false },
                    //{ text: this.$t('PostStatus'), value: 'isActive', sortable: false }
                ];
            }
        }
    };
</script> 